export function getRoundingMethod(method) {
  return function (number) {
    var round = method ? Math[method] : Math.trunc;
    var result = round(number);
    // Prevent negative zero
    return result === 0 ? 0 : result;
  };
}